import { arrayEmpty, arrayNotEmpty } from 'src/app/utils/array.utils';
import { fileModelToXml, getXmlBoolean, getXmlLine } from 'src/app/utils/soap.utils';
import {
    ExemplaireMediathequeRechercheMediaModelDto,
    FicheMediaMediathequeModel,
    MediathequeEmpruntReservationFamilleModel,
    MediathequeInformationsFamilleModel,
    MediathequeReservationEnLigneFamilleModel,
    ModeleRegleAccChpListValModeGuide,
    ModeleRegleAccessibiliteMediathequeInput,
    ModeleRegleQuotaMediathequeInput,
    ModeleRegleQuotaRessourcesPartageesInput,
    ModeleSaveReglesAfpadto,
    ParamMediathequeCatalogueModel,
    ParamMediathequeFamilleModel,
    ParamRessourceModel,
    ParamRessourcePartageeFpaModel,
    RegleExpertModel,
    RessourceComptabiliteModel,
    RessourceDescriptionModel,
    RessourceInformationsModel,
    RetourApiMediaModel,
    TypeAfpaEnum
} from 'src/graphql/generated-types';

export type mediaInformations = FicheMediaMediathequeModel | RetourApiMediaModel;

export function mediaLibrariesFamilyToXML(family: ParamMediathequeFamilleModel): string {
    return `
<famille
    xmlns:dto="http://schemas.datacontract.org/2004/07/V2DTO"
    xmlns:arrayElement="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
    xmlns:i="http://www.w3.org/2001/XMLSchema-instance">

    ${mediaLibrariesFamilyLoanModelToXML(family.FamilleEmpruntReservationModel, 'FamilleEmpruntReservationModel')}
    ${mediaLibrariesFamilyInformationsModelToXML(family.FamilleInformationsModel)}
    ${mediaLibrariesFamilyOnlineModelToXML(family.InfosReservationEnLigne, 'InfosReservationEnLigne')}
    ${mediaLibrariesRulesModelToXML(family.ModeleSaveReglesAFPA, mediaLibrariesSubQuotaRuleToXML)}
</famille>
    `;
}

export function mediaLibrariesCatalogToXML(media: ParamMediathequeCatalogueModel): string {
    return `
<catalogue
    xmlns:dto="http://schemas.datacontract.org/2004/07/V2DTO"
    xmlns:arrayElement="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
    xmlns:i="http://www.w3.org/2001/XMLSchema-instance">

    ${mediaLibrariesFamilyLoanModelToXML(media.CatalogueEmpruntReservationModel, 'CatalogueEmpruntReservationModel')}
    ${mediaLibrariesCatalogInformationsModelToXML(media.CatalogueFicheMediaModel)}
    ${mediaLibrariesFamilyOnlineModelToXML(media.CatalogueInfosReservationEnLigne, 'CatalogueInfosReservationEnLigne')}
    ${mediaLibrariesCatalogExemplariesListToXML(media.CatalogueListeExemplairesMediaModel?.MediathequeExemplaireCatalogueMediaModel, 'CatalogueListeExemplairesMediaModel')}
    ${mediaLibrariesRulesModelToXML(media.ModeleSaveReglesAFPA)}
</catalogue>
    `;
}

export function mediaLibrariesFamilyLoanModelToXML(loanModel: MediathequeEmpruntReservationFamilleModel, name: string): string {
    return `
    <dto:${name}>
            ${getXmlLine(loanModel, 'HeureDebutEmpruntDefaut', {namespace: 'dto'})}
            ${getXmlLine(loanModel, 'HeureFinEmpruntDefaut', {namespace: 'dto'})}
            ${getXmlBoolean(loanModel, 'IsDateADate', {namespace: 'dto', defaultValue: false})}
            ${getXmlLine(loanModel, 'IsFilDAttente', {namespace: 'dto', defaultValue: false})}
            ${getXmlLine(loanModel, 'IsJoursOuvres', {namespace: 'dto', defaultValue: false})}
            ${getXmlLine(loanModel, 'IsPermanences', {namespace: 'dto', defaultValue: false})}
            ${getXmlLine(loanModel, 'JourSuivant', {namespace: 'dto'})}
            ${getXmlLine(loanModel, 'NbHeuresOuvres', {namespace: 'dto'})}
            ${getXmlLine(loanModel, 'NbJoursOuvres', {namespace: 'dto'})}
            ${getXmlLine(loanModel, 'NbMinutesOuvres', {namespace: 'dto'})}
            ${getXmlLine(loanModel, 'NbPermanences', {namespace: 'dto'})}
            ${getXmlLine(loanModel, 'RedescendreSurEnfants', {namespace: 'dto'})}
            ${getXmlLine(loanModel, 'TarifLibelleDefaut', {namespace: 'dto'})}
            ${getXmlBoolean(loanModel, 'VueReservationJour', {namespace: 'dto'})}
            ${getXmlBoolean(loanModel, 'VueReservationMois', {namespace: 'dto'})}
            ${getXmlBoolean(loanModel, 'VueReservationSemaine', {namespace: 'dto'})}
        </dto:${name}>
    `;
}

export function mediaLibrariesFamilyInformationsModelToXML(informationsModel: MediathequeInformationsFamilleModel): string {
    const picture = informationsModel.Illustration;
    return `
<dto:FamilleInformationsModel>
    ${getXmlLine(informationsModel, 'Code', {namespace: 'dto'})}
    ${getXmlLine(informationsModel, 'Description', {namespace: 'dto'})}
    ${getXmlLine(informationsModel, 'IdActivite', {namespace: 'dto'})}
    ${getXmlLine(informationsModel, 'IdFamille', {namespace: 'dto'})}
    ${!!picture ? fileModelToXml(picture, 'Illustration', {namespace: 'dto'}) : ''}
    ${getXmlBoolean(informationsModel, 'IsClos', {namespace: 'dto'})}
    ${getXmlBoolean(informationsModel, 'IsConsidererNouveauxProduits', {namespace: 'dto'})}
    ${getXmlLine(informationsModel, 'Libelle', {namespace: 'dto'})}
    ${getXmlLine(informationsModel, 'NbJoursConsidererNouveauxProduits', {namespace: 'dto'})}
    ${getXmlBoolean(informationsModel, 'RedescendreImage', {namespace: 'dto'})}
    ${getXmlLine(informationsModel, 'TypeParDefautDesProduits', {namespace: 'dto'})}
</dto:FamilleInformationsModel>
    `;
}

export function mediaLibrariesFamilyOnlineModelToXML(onlineModel: MediathequeReservationEnLigneFamilleModel, name: string): string {
    return `
<dto:${name}>
    ${getXmlBoolean(onlineModel, 'IsAfficherSurSiteCE', {namespace: 'dto'})}
    ${getXmlBoolean(onlineModel, 'IsAutoriserResaSurSiteCE', {namespace: 'dto'})}
    ${getXmlBoolean(onlineModel, 'RedescendreSurEnfants', {namespace: 'dto'})}
    ${getXmlLine(onlineModel, 'VisibleAu', {namespace: 'dto'})}
    ${getXmlLine(onlineModel, 'VisibleDu', {namespace: 'dto'})}
</dto:${name}>
    `;
}

export function mediaLibrariesRulesModelToXML(ruleModel: ModeleSaveReglesAfpadto, quotaRuleToXMLCallBack?: (quotaRule) => string): string {
    return `
<dto:ModeleSaveReglesAFPA>
    ${getXmlLine(ruleModel, 'IdElement', {namespace: 'dto'})}
    ${getXmlLine(ruleModel, 'IdParent', {namespace: 'dto'})}
    ${getAdvancedRulesListXML((ruleModel?.ListeRegles?.anyType as RegleExpertModel[]) || [])}
    <dto:ModeleDeploiementRegles  i:type="dto:ModeleDeploiementReglesBase">
        ${getXmlLine(ruleModel?.ModeleDeploiementRegles, 'RedescenteRegleAccessibilite', {
        namespace: 'dto',
        defaultValue: false
    })}
        ${getXmlLine(ruleModel?.ModeleDeploiementRegles, 'RedescenteRegleQuota', {
        namespace: 'dto',
        defaultValue: false
    })}
    </dto:ModeleDeploiementRegles>
    ${accessibilityRuleCriteriaListModelToXML(ruleModel?.ModeleRegleAccChplistval?.anyType || [])}
    ${mediaLibrariesAccessibilityRuleToXML(ruleModel?.ModeleRegleAccessibilite)}
    ${quotaRuleToXMLCallBack ? quotaRuleToXMLCallBack(ruleModel?.ModeleRegleSubQuota) : ''}
    ${getXmlLine(ruleModel, 'TypeElement', {namespace: 'dto', defaultValue: TypeAfpaEnum.Famille})}
</dto:ModeleSaveReglesAFPA>
    `;
}

function getAdvancedRulesListXML(rulesList: RegleExpertModel[]): string {
    const advancedRuleToXML = (rule: RegleExpertModel): string => `
<arrayElement:anyType  i:type="dto:RegleExpertModel">
    ${getXmlLine(rule, 'IdRegle', {namespace: 'dto'})}
    ${getXmlBoolean(rule, 'IsAccessibilite', {namespace: 'dto'})}
    ${getXmlBoolean(rule, 'IsEnveloppe', {namespace: 'dto'})}
    ${getXmlBoolean(rule, 'IsHerite', {namespace: 'dto'})}
    ${getXmlBoolean(rule, 'IsModeExpert', {namespace: 'dto'})}
    ${getXmlBoolean(rule, 'IsQuota', {namespace: 'dto'})}
    ${getXmlBoolean(rule, 'IsRegleHeritage', {namespace: 'dto'})}
    ${getXmlBoolean(rule, 'IsRestantACharge', {namespace: 'dto'})}
    ${getXmlBoolean(rule, 'IsSubvention', {namespace: 'dto'})}
    ${getXmlBoolean(rule, 'IsSubventionComplementaire', {namespace: 'dto'})}
    ${getXmlLine(rule, 'Libelle', {namespace: 'dto'})}
    ${getXmlLine(rule, 'NeedsToBeDeleted', {namespace: 'dto'})}
</arrayElement:anyType>
    `;

    return `
<dto:ListeRegles>
    ${rulesList.map(rule => advancedRuleToXML(rule)).join('\n\t')}
</dto:ListeRegles>
    `;
}

function accessibilityRuleCriteriaListModelToXML(criteriaList: ModeleRegleAccChpListValModeGuide[]): string {
    const criterionToXML = (criterion: ModeleRegleAccChpListValModeGuide): string => `
        <arrayElement:anyType i:type="dto:ModeleRegleAccChpListValModeGuide">
            ${getXmlLine(criterion, 'IdChpListVal', {namespace: 'dto'})}
            ${getXmlLine(criterion, 'IdRegleAccessibilite', {namespace: 'dto'})}
            ${getXmlBoolean(criterion, 'IsCheckedValeur', {namespace: 'dto'})}
            ${getXmlLine(criterion, 'Libelle', {namespace: 'dto'})}
            ${getXmlLine(criterion, 'ValeurAncienneteMax', {namespace: 'dto'})}
            ${getXmlLine(criterion, 'ValeurAncienneteMin', {namespace: 'dto'})}
        </arrayElement:anyType>
    `;

    return `
<dto:ModeleRegleAccChplistval>
    ${criteriaList?.map(criterionToXML)?.join('\n\t') || ''}
</dto:ModeleRegleAccChplistval>
    `;
}

function mediaLibrariesAccessibilityRuleToXML(accessibilityRule: ModeleRegleAccessibiliteMediathequeInput): string {
    return `
<dto:ModeleRegleAccessibilite i:type="dto:ModeleRegleAccessibiliteMediatheque">
    ${getXmlLine(accessibilityRule, 'IdChampOuvrantDroit', {namespace: 'dto'})}
    ${getXmlLine(accessibilityRule, 'IdModeleRegle', {namespace: 'dto'})}
    ${getXmlLine(accessibilityRule, 'IdTypeDateCalculAnciennete', {namespace: 'dto'})}
    ${getXmlLine(accessibilityRule, 'IsAccessibleSelonCritere', {namespace: 'dto', defaultValue: false})}
    ${getXmlLine(accessibilityRule, 'IsAccessibleTousOuvrantsDroit', {namespace: 'dto', defaultValue: false})}
    ${getXmlLine(accessibilityRule, 'IsForcageAutorise', {namespace: 'dto', defaultValue: false})}
    ${getXmlLine(accessibilityRule, 'JourDateFixe', {namespace: 'dto'})}
            <dto:ListeValeursCritere>
    ${!accessibilityRule?.IsAccessibleTousOuvrantsDroit && arrayNotEmpty(accessibilityRule?.ListeValeursCritere?.anyType) ? `
            ${accessibilityRule.ListeValeursCritere.anyType.map(criteria => `
                <arrayElement:anyType i:type="dto:ModeleRegleAccChpListValModeGuide">
                    ${getXmlLine(criteria, 'IdChpListVal', {namespace: 'dto'})}
                    ${getXmlLine(criteria, 'IsCheckedValeur', {namespace: 'dto', defaultValue: true})}
                    ${getXmlLine(criteria, 'Libelle', {namespace: 'dto'})}
                    ${getXmlLine(criteria, 'ValeurAncienneteMax', {namespace: 'dto'})}
                    ${getXmlLine(criteria, 'ValeurAncienneteMin', {namespace: 'dto'})}
                </arrayElement:anyType>
            `).join('')}
    ` : ''
    }
        </dto:ListeValeursCritere>
    ${getXmlLine(accessibilityRule, 'ModeCalculAccessibilite', {namespace: 'dto'})}
    ${getXmlLine(accessibilityRule, 'MoisDateFixe', {namespace: 'dto'})}
    ${getXmlLine(accessibilityRule, 'NbMoisAncienneteMax', {namespace: 'dto'})}
    ${getXmlLine(accessibilityRule, 'NbMoisAncienneteMin', {namespace: 'dto'})}
    ${getXmlLine(accessibilityRule, 'NombreJoursAvantFinContrat', {namespace: 'dto'})}
    ${getXmlLine(accessibilityRule, 'NombreJoursDeRetardSurEmpruntEnCours', {namespace: 'dto'})}
</dto:ModeleRegleAccessibilite>
    `;
}

export function mediaLibrariesSubQuotaRuleToXML(quotaRule: ModeleRegleQuotaMediathequeInput): string {
    return `
<dto:ModeleRegleSubQuota i:type="dto:ModeleRegleQuotaMediatheque">
    ${getXmlLine(quotaRule, 'Status', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'IdModeleRegle', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreAutresMediasNouveaute', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreAutresMediasTotal', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreCDNouveaute', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreCDTotal', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreDVDNouveaute', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreDVDTotal', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreLivresNouveaute', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreLivresTotal', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreLogicielsNouveaute', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreLogicielsTotal', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreMediasNouveaute', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreMediasTotal', {namespace: 'dto'})}
</dto:ModeleRegleSubQuota>
    `;
}

function mediaLibrariesCatalogInformationsModelToXML(mediaInformations: mediaInformations): string {
    const picto = (mediaInformations as FicheMediaMediathequeModel)?.Picto;

    return `
<dto:CatalogueFicheMediaModel>
    ${getXmlLine(mediaInformations, 'Auteur', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'CDU', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Cible', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Collection', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Cote', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'CritiqueMedia', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'DEWAY', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'DateEdition', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'DateSortie', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Duree', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Editeur', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Format', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Genre', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'ISBN10', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Image', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'ImageOrigine', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Libre', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'LivretDispoMedia', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Nationalite', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'NbPageOrDisk', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Note', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Numerotation', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Realisateur', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Reference', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'SousCollec', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'SousTitre', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Synopsis', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Theme', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Titre', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'Type', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'CodeFamille', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'DateAchat', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'DateAchatString', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'DateDebutNouveaute', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'DateFinNouveaute', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'IdDelegation', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'IdEnveloppe', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'IdFamille', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'IdProduit', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'ImagePerso', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'IsCloture', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'IsFamilleCloture', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'IsMAJApi', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'LibelleFamille', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'LieuAchat', {namespace: 'dto'})}
    ${!!picto ? fileModelToXml(picto, 'Picto', {namespace: 'dto'}) : ''}
    ${getXmlLine(mediaInformations, 'PrixAchat', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'PrixAchatString', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'TypeMedia', {namespace: 'dto'})}
    ${getXmlLine(mediaInformations, 'WithRemplacementDonneesFromAPI', {namespace: 'dto'})}
</dto:CatalogueFicheMediaModel>
    `;
}

export function mediaLibrariesCatalogExemplariesListToXML(examplaryList: ExemplaireMediathequeRechercheMediaModelDto[], name: string): string {
    if (arrayEmpty(examplaryList)) {
        return '';
    }
    return `
<dto:${name}>
    ${examplaryList.map(examplary => `
    <dto:MediathequeExemplaireCatalogueMediaModel>
        ${getXmlLine(examplary, 'Auteur', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'BenefEmprunte', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'BenefEnFileDattente', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'BenefReserve', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'BenefRetard', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'Code', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'Cote', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'EtatExemplaire', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'IdBenefEmprunte', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'IdEnveloppe', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'IdEtatExemplaire', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'IdExemplaire', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'IdProduit', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'IdStockActuel', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'IdStockRattachement', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'IsBloque', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'IsEmprunte', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'IsEnFileDattente', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'IsEnStock', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'IsEnTransfert', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'IsGereEnFileAttente', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'IsPerdu', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'IsReserve', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'IsRetard', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'IsSelected', {namespace: 'dto', defaultValue: false})}
        ${getXmlLine(examplary, 'Localisation', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'QteFileEnAttente', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'Remarque', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'StockRattachement', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'TitreMedia', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'ToDelete', {namespace: 'dto'})}
        ${getXmlLine(examplary, 'TypeMedia', {namespace: 'dto'})}
    </dto:MediathequeExemplaireCatalogueMediaModel>
    `).join('\n')}
</dto:${name}>
    `;
}

export function sharedResourcesFamilyToXML(family: ParamRessourcePartageeFpaModel): string {
    return `
<famille xmlns:dto="http://schemas.datacontract.org/2004/07/V2DTO"
         xmlns:arrayElement="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
         xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
    ${sharedResourcesAccountabilityToXML(family.ComptabiliteRessource, 'ComptabiliteRessource')}
    ${mediaLibrariesFamilyLoanModelToXML(family.FamilleEmpruntReservationModel, 'FamilleEmpruntReservationModel')}
    ${mediaLibrariesFamilyInformationsModelToXML(family.FamilleInformationsModel)}
    ${mediaLibrariesFamilyOnlineModelToXML(family.InfosReservationEnLigne, 'InfosReservationEnLigne')}
    ${mediaLibrariesRulesModelToXML(family.ModeleSaveReglesAFPA, sharedResourcesQuotaRuleToXML)}
</famille>
    `;
}

export function sharedResourcesCatalogToXML(resource: ParamRessourceModel): string {
    return `
<ressourceModel xmlns:dto="http://schemas.datacontract.org/2004/07/V2DTO"
                xmlns:arrayElement="http://schemas.microsoft.com/2003/10/Serialization/Arrays"
                xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
    ${mediaLibrariesFamilyOnlineModelToXML(resource.CatalogueInfosReservationEnLigne, 'CatalogueInfosReservationEnLigne')}
    ${sharedResourcesAccountabilityToXML(resource.ComptabiliteRessourceModel, 'ComptabiliteRessourceModel')}
    ${sharedResourceDescriptionTOXML(resource.DescriptionRessource)}
    ${mediaLibrariesFamilyLoanModelToXML(resource.EmpruntReservationRessourceModel, 'EmpruntReservationRessourceModel')}
    ${sharedResourceInformationToXml(resource.InformationsRessourceModel)}
    ${mediaLibrariesCatalogExemplariesListToXML(resource.ListeExemplaireRessourceModel?.MediathequeExemplaireCatalogueMediaModel, 'ListeExemplaireRessourceModel')}
    ${mediaLibrariesRulesModelToXML(resource.ModeleSaveReglesAFPA)}
</ressourceModel>
    `;
}

export function sharedResourcesQuotaRuleToXML(quotaRule: ModeleRegleQuotaRessourcesPartageesInput): string {
    return `
<dto:ModeleRegleSubQuota i:type="dto:ModeleRegleQuotaRessourcesPartagees">
    ${getXmlLine(quotaRule, 'IdModeleRegle', {namespace: 'dto'})}
    ${getXmlBoolean(quotaRule, 'IsForcageAutorise', {namespace: 'dto'})}
    ${getXmlBoolean(quotaRule, 'IsVenteSansSubvention', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'OrdreModeleRegle', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreEmpruntNouveaute', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreEmpruntTotal', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreResaAttenteNouveaute', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreResaAttenteTotal', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreResaValideNouveaute', {namespace: 'dto'})}
    ${getXmlLine(quotaRule, 'NombreResaValideTotal', {namespace: 'dto'})}
</dto:ModeleRegleSubQuota>
    `;
}

function sharedResourcesAccountabilityToXML(accountability: RessourceComptabiliteModel, name: string): string {
    return `
<dto:${name}>
    ${getXmlLine(accountability, 'IdCompteProduit', {namespace: 'dto'})}
    ${
        arrayNotEmpty(accountability?.ListePlanSectionAnalytique?.PlanWithSectionsAnalytiquesModel) ? `
    <dto:ListePlanSectionAnalytique>
        ${accountability.ListePlanSectionAnalytique.PlanWithSectionsAnalytiquesModel.map(plan => `
        <dto:PlanWithSectionsAnalytiquesModel>
            <dto:IdPlan>${plan.IdPlan}</dto:IdPlan>
            ${getXmlLine(plan, 'IdSectionAnalytique', {namespace: 'dto'})}
        </dto:PlanWithSectionsAnalytiquesModel>
        `).join('')
        }
    </dto:ListePlanSectionAnalytique>
        ` : ''
    }
</dto:${name}>
    `;
}

function sharedResourceDescriptionTOXML(description: RessourceDescriptionModel): string {
    return `
<dto:DescriptionRessource>
    ${getXmlLine(description, 'DescriptionRessource', {namespace: 'dto'})}
    ${arrayNotEmpty(description?.ListeImages?.FichierModel) ? `
    <dto:ListeImages>
        ${description.ListeImages.FichierModel.map(file => fileModelToXml(file, 'FichierModel', {namespace: 'dto'})).join('\n\t\t')}
    </dto:ListeImages>
    ` : ''}
</dto:DescriptionRessource>
    `;
}

function sharedResourceInformationToXml(informations: RessourceInformationsModel): string {
    return `
<dto:InformationsRessourceModel>
    ${getXmlLine(informations, 'CodeFamille', {namespace: 'dto'})}
    ${getXmlLine(informations, 'DateDebutNouveaute', {namespace: 'dto'})}
    ${getXmlLine(informations, 'DateFinNouveaute', {namespace: 'dto'})}
    ${getXmlLine(informations, 'IdEnveloppe', {namespace: 'dto'})}
    ${getXmlLine(informations, 'IdFamille', {namespace: 'dto'})}
    ${getXmlLine(informations, 'IdProduit', {namespace: 'dto'})}
    ${fileModelToXml(informations?.Illustration, 'Illustration', {namespace: 'dto',})}
    ${getXmlBoolean(informations, 'IsCloture', {namespace: 'dto'})}
    ${getXmlBoolean(informations, 'IsGereEnStock', {namespace: 'dto'})}
    ${getXmlLine(informations, 'LibelleFamille', {namespace: 'dto'})}
    ${getXmlLine(informations, 'LibelleProduit', {namespace: 'dto'})}
    ${getXmlLine(informations, 'TokenIllustration', {namespace: 'dto'})}
</dto:InformationsRessourceModel>
    `;
}
